export enum ToastLevel
{
    None,
    Information,
    Warning,
    Success
}

export class ToastMessage
{
    public content: any = null;
    public level: ToastLevel = ToastLevel.None;
    public extra: string = "";
    public timeout: number = 5000;
    public progressBar: boolean = true;
    public closeButton: boolean = true;

    static create(
        content: any,
        level: ToastLevel = ToastLevel.None,
        extra: string= "",
        options: Partial<ToastMessage> = {})
    {
        let t = new ToastMessage();
        t.content = content;
        t.level = level;
        t.extra = extra;
        t.timeout = 5000;
        t.progressBar = true;
        t.closeButton = true;

        Object.assign(t, options);

        return t;
    }
    
    // constructor(content: any, level: ToastLevel = ToastLevel.None, extra: string= "")
    // {
    //     this.content = content;
    //     this.level = level;
    //     this.extra = extra;
    // }
}